import styled from "styled-components";
import { theme } from "@themes";

export const ContentModal = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentModalActiveSurvey = styled.div`
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  width: 483px;
  height: 299px;
`;

export const CloseModalActiveSurvey = styled.div`
  height: 51px;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  a {
    color: ${({ theme }) => theme.primaryColorDark};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModalActiveSurvey = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  height: 180px;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 16px;
    color: ${({ theme }) => theme.neutral.black};
    font-weight: 400;
    height: auto;
    width: 352px;
  }

  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ButtonActiveSurvey = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 98px;
  height: 37px;
    background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  color: white;
  margin: ${({ showCancel }) => (showCancel ? "0" : "0 10px")};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    background-color: rgba(46, 46, 46, 1);
  }
`;
export const ButtonActiveSurveyCancel = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 98px;
  height: 37px;
  background: white;
  border-radius: 4px;
  border: 1px solid;
  margin: 0 10px;
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;
export const ActionButtons = styled.div`
  height: 66px;
  display: flex;
  margin: auto;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
`;

export const ModalTitle = styled.label`
  font-size: 18px;
  color: ${({ theme }) => theme.neutral.black};
  font-weight: 600;
  position: absolute;
  left: 31px;
  top: 17px;
`;
